import { render, staticRenderFns } from "./AdminOrganizationAutocomplete.vue?vue&type=template&id=66d8a444&"
import script from "./AdminOrganizationAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./AdminOrganizationAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports